/* eslint-disable no-useless-catch */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import { useGetClienteCarteira } from "~pages/Wallet/hooks/useWallet";
import { useLiveQuery } from "dexie-react-hooks";

const useCliente = (id, enabledFetch = true) => {
  const [cliente, setCliente] = useState();
  const [enabledGetCliente, setEnabledGetCliente] = useState(false);

  const getClienteCarteira = useCallback(async () => {
    const clienteCarteira = id && id != "undefined" ? await db.cliente.get(parseInt(id)) : null;
    setCliente(clienteCarteira);
  }, [id]);

  const fetchCarteira = useCallback(async () => {
    await getClienteCarteira();

    if (id && id !== "undefined" && enabledFetch)
      setEnabledGetCliente(true)
  }, [getClienteCarteira, id, enabledFetch]);

  const setClienteCarteira = useCallback(async (cliente) => {
    if (!cliente) return;
    const clienteLocal = await db.cliente.get(cliente.id);
    await db.cliente.put(clienteLocal
      ? { ...clienteLocal, ...cliente, clienteCarteira: clienteLocal.clienteCarteira, clienteProspect: clienteLocal.clienteProspect, recebedor: clienteLocal.recebedor }
      : cliente);
    await fetchCarteira();
  }, [fetchCarteira]);

  const useRemoveCallback = () => {
    return useMemo(() => {
      return async () => {
        try {
          return await db.cliente.where({ id: parseInt(id) }).delete();
        } catch (error) {
          throw error
        }
      };
    }, [id]);
  };

  const clienteRequest = useGetClienteCarteira(id, enabledGetCliente)

  useEffect(() => {
    if (clienteRequest.data && enabledGetCliente) {
      setClienteCarteira(clienteRequest.data)
    }
  }, [clienteRequest.data, enabledGetCliente, setClienteCarteira])

  useEffect(() => {
    fetchCarteira();
  }, [fetchCarteira])

  return {
    cliente,
    useRemoveCallback
  };
}

export default useCliente;
